import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    groutJointSize: {
        position: 'relative',
        marginBottom: '56px',
    },
    wrapper: {
        '@media print': {
            padding: '20px 10px',
        },
    },
    groutJointSizeContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: defaultStyles.greyWhite,
        '@media print, screen and (min-width: 990px)': {
            flexDirection: 'row',
        },
    },
    groutJointSizeText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '@media print, screen and (min-width: 990px)': {
            paddingRight: '2rem',
            maxWidth: '70%',
            flex: '0 0 70%',
        },
    },
    h3: {
        marginTop: 0,
    },
    paragraph: {
        marginTop: '16px',
        marginBottom: '2rem',
        textAlign: 'center',
        '@media print, screen and (min-width: 990px)': {
            textAlign: 'left',
            marginLeft: '40px',
        },
        '@media print': {
            marginBottom: '0',
            marginLeft: '16px',
        },
    },
    inputsRegion: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '@media print, screen and (min-width: 700px)': {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '@media print, screen and (min-width: 990px)': {
            justifyContent: 'flex-start',
        },
    },
    figure: {
        margin: '0',
        width: '100%',
        padding: '48px 0',
        backgroundColor: defaultStyles.greyBackground,
        '@media screen and (min-width: 990px)': {
            maxWidth: '30%',
            flex: '0 0 30%',
        },
    },
    image: {
        maxWidth: '60%',
        display: 'block',
        margin: '0 auto',
        '@media screen and (min-width: 990px)': {
            width: '200px',
        },
        '@media print': {
            maxWidth: '40%',
        }
    },
    error: {
        marginTop: '16px',
    },
    contentError: {
        border: '1px solid ' + defaultStyles.red,
    }
});

export default styles;
